export default "__VITE_ASSET__Bwk8nuMY__"